import { Circle, skinVars } from '@telefonica/mistica';
import React, { useEffect, useState } from 'react';
import ChatText from '../ChatText';
import './index.scss';
import BrandLogo from '../../assets/images/BrandLogo.svg';

export interface ChatSupportData {
    text: any;
    html?: boolean;
}

export const ChatSupport: React.FC<ChatSupportData> = ({ text, html = false }: ChatSupportData) => {
    const [windowWidth, setWindowWidth] = useState<any>(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const iconSize = windowWidth >= 1024 ? 16 : 10;

    return (
        <div className='chatSupport'>
            <Circle size={windowWidth >= 1024 ? 32 : 24} backgroundColor={skinVars.colors.brand}>
                <img
                    src={BrandLogo}
                    alt='Brand logo'
                    style={{
                        width: `${iconSize}px`,
                        height: `${iconSize}px`,
                        display: 'block',
                    }}
                    draggable={false}
                />
            </Circle>
            <ChatText context={'answer'} text={text} html={html}></ChatText>
        </div>
    );
};

export default ChatSupport;
